import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { isAuthenticated, loading, isAdmin, isExpired, authInitFailed } = useAuth();

    // Firebase never came up. Sending the user to the login page would be a lie — signing in is
    // exactly what cannot work — so say so instead of looping them through a form that will fail.
    if (authInitFailed) {
        return (
            <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
                <h3>Sign-in is temporarily unavailable</h3>
                <p>The authentication service could not be reached. Please reload in a moment.</p>
                <p style={{ color: '#666', fontSize: 13 }}>
                    If this persists, the browser console records the underlying error.
                </p>
            </div>
        );
    }

    if (loading) {
        return <div>Loading...</div>; // Or a spinner component
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Expired non-admin users are redirected to login with a prompt to renew
    if (!isAdmin && isExpired) {
        return <Navigate to="/login?expired=true" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
